<div class="delete-domain-dialog delete-domain-container">
  <mat-card-content>
    {{
      'PAGES.DOMAINS.DELETE_DOMAIN_MODAL.TITLE' | translate: { domain: domain }
    }}
  </mat-card-content>
  <mat-card-actions layout-align="end right">
    <button
      type="button"
      mat-raised-button
      color="accent"
      [disabled]="disableInput"
      (click)="onOKClick()"
    >
      {{
        'PAGES.DOMAINS.DELETE_DOMAIN_MODAL.BUTTONS.DELETE_DOMAIN' | translate
      }}
    </button>
    <button
      type="button"
      mat-button
      color="accent"
      [disabled]="disableInput"
      (click)="onCancelClick()"
    >
      {{ 'PAGES.DOMAINS.BUTTONS.CANCEL' | translate }}
    </button>
    <mat-spinner
      class="info-spinner-small"
      [style.visibility]="disableInput ? 'visible' : 'hidden'"
      color="accent"
      [diameter]="30"
      [strokeWidth]="4"
    ></mat-spinner>
  </mat-card-actions>
</div>
